<template>
  <div>
    <h5>{{ created }}</h5>
  </div>
</template>

<script>
import {formatDT} from '../utils'

export default {
  name: 'OrdersTableCellCreated',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    created: function () {
      return formatDT(this.row.info.created)
    }
  },
  components: {}
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/OrdersTableCellCreated.vue